var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFitnessWeightlift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18800_33170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.98364 9.84662C9.98364 10.5428 10.2602 11.2105 10.7525 11.7028C11.2448 12.1951 11.9124 12.4716 12.6086 12.4716C13.3048 12.4716 13.9725 12.1951 14.4648 11.7028C14.9571 11.2105 15.2336 10.5428 15.2336 9.84662C15.2336 9.15043 14.9571 8.48275 14.4648 7.99046C13.9725 7.49818 13.3048 7.22162 12.6086 7.22162C11.9124 7.22162 11.2448 7.49818 10.7525 7.99046C10.2602 8.48275 9.98364 9.15043 9.98364 9.84662V9.84662Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37354 9.47162C4.46621 11.8252 5.33662 14.0816 6.84853 15.8876C7.61491 16.7203 8.55797 17.3709 9.60853 17.7916V23.7216",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6875 6.62961C18.4195 6.76387 18.1978 6.9754 18.0511 7.23689C17.9044 7.49838 17.8394 7.79784 17.8645 8.09661C17.8645 8.13261 18.1075 11.7406 16.1645 13.8556C15.8358 14.2019 15.4544 14.4942 15.0345 14.7216H10.1835C9.76956 14.4972 9.3925 14.2105 9.06554 13.8716C7.10854 11.7496 7.34854 8.16061 7.35454 8.09161C7.37848 7.79343 7.31272 7.49491 7.16571 7.23439C7.0187 6.97387 6.79716 6.76326 6.52954 6.62961",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6086 23.7216V17.7916C16.6588 17.372 17.6019 16.7229 18.3686 15.8916C19.8814 14.0845 20.7518 11.8265 20.8436 9.47162",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8596 4.22663C15.4056 3.22064 9.81362 3.22064 4.35962 4.22663",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8586 5.72162C23.8586 6.11944 23.7006 6.50097 23.4193 6.78228C23.138 7.06358 22.7565 7.22162 22.3586 7.22162C21.9608 7.22162 21.5793 7.06358 21.298 6.78228C21.0167 6.50097 20.8586 6.11944 20.8586 5.72162V2.72162C20.8586 2.32379 21.0167 1.94226 21.298 1.66096C21.5793 1.37965 21.9608 1.22162 22.3586 1.22162C22.7565 1.22162 23.138 1.37965 23.4193 1.66096C23.7006 1.94226 23.8586 2.32379 23.8586 2.72162V5.72162Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.35864 5.72162C4.35864 6.11944 4.20061 6.50097 3.9193 6.78228C3.638 7.06358 3.25647 7.22162 2.85864 7.22162C2.46082 7.22162 2.07929 7.06358 1.79798 6.78228C1.51668 6.50097 1.35864 6.11944 1.35864 5.72162V2.72162C1.35864 2.32379 1.51668 1.94226 1.79798 1.66096C2.07929 1.37965 2.46082 1.22162 2.85864 1.22162C3.25647 1.22162 3.638 1.37965 3.9193 1.66096C4.20061 1.94226 4.35864 2.32379 4.35864 2.72162V5.72162Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18800_33170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.608643 0.47168)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessWeightlift);
export default __webpack_public_path__ + "static/media/fitness-weightlift.42ccebc134438dd2e6f63472c6d1f1c7.svg";
export { ForwardRef as ReactComponent };